import { useEffect, useState } from 'react';

export default function usePersistantState<T>(
  key: string,
  initialValue: T
): [T, ( value: T ) => void] {
  const [ state, setInternalState ] = useState<T>( initialValue );

  useEffect( () => {
    const value = localStorage.getItem( key );

    if ( !value ) {return;}
    try {
      setInternalState( JSON.parse( value ) );
    } catch {
      setInternalState( value as T );
    }
  }, [ key ] );

  const setState = ( value: T ) => {
    localStorage.setItem( key, JSON.stringify( value ) );
    setInternalState( value );
  };

  return [ state, setState ];
}

